<template>
  <b-form-group class="phone-editor">
    <b-form-input
      v-model="value.phone_number"
      type="tel"
      placeholder="Введите номер телефона"
    />
    <div class="phone-editor__messengers">
      <b-form-checkbox
        v-model="value.has_telegram"
        value="1"
        unchecked_value="0"
        class="phone-editor__messengers__checkbox"
      >
        Telegram
      </b-form-checkbox>
      <b-form-checkbox
        v-model="value.has_viber"
        value="1"
        unchecked_value="0"
        class="phone-editor__messengers__checkbox"
      >
        Viber
      </b-form-checkbox>
      <b-form-checkbox
        v-model="value.has_whatsapp"
        value="1"
        unchecked_value="0"
        class="phone-editor__messengers__checkbox"
      >
        WhatsApp
      </b-form-checkbox>
    </div>
  </b-form-group>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: false
    }
  }
};
</script>

<style lang="scss">
.phone-editor {
  &__messengers {
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    &__checkbox {
      margin-left: 10px;
      &:first-child {
        margin-left: 5px;
      }
    }
  }
}
</style>
